import { z } from 'zod';

// One row of the address search on `GET /app_service/panel/v1/locations?q=`. The id is an
// INTEGER, and the pair is already the domain shape — no snake_case to map, so no transform.
export const LocationMatchSchema = z.object({
  id: z.number(),
  address: z.string(),
});

// The search envelope. It is NOT the DRF cursor envelope the other list reads use: there is
// no `next`/`previous` and no cap — everything matching comes back in one answer.
export const LocationSearchResponseSchema = z.object({
  count: z.number(),
  results: z.array(LocationMatchSchema),
});

export type LocationMatch = z.infer<typeof LocationMatchSchema>;
export type LocationSearchResponse = z.infer<typeof LocationSearchResponseSchema>;
